import { render, staticRenderFns } from "./productGroupOrderManage.vue?vue&type=template&id=1b75d867&scoped=true"
import script from "./productGroupOrderManage.vue?vue&type=script&lang=js"
export * from "./productGroupOrderManage.vue?vue&type=script&lang=js"
import style0 from "./productGroupOrderManage.vue?vue&type=style&index=0&id=1b75d867&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b75d867",
  null
  
)

export default component.exports